var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
var ItemTitle = styled.h3(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: bold;\n  font-size: 0.875rem;\n  margin: 0;\n"], ["\n  color: ", ";\n  font-weight: bold;\n  font-size: 0.875rem;\n  margin: 0;\n"])), function (p) { return p.theme.colorPrimary; });
export default ItemTitle;
var templateObject_1;
